/* eslint-disable */
import PropTypes from 'prop-types';
import I18nEntityPropTypes from '../../Services/I18n/I18n.service.props';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const ThemePropTypes = {
  /**
   * The theme options
   */
  themeOptions: PropTypes.shape({
    direction: I18nEntityPropTypes.direction.isRequired,
    palette: PropTypes.shape({
      error: ThemeStatePropTypes.color.isRequired,
      primary: ThemeStatePropTypes.color.isRequired,
      secondary: ThemeStatePropTypes.color.isRequired,
      type: ThemeStatePropTypes.paletteType.isRequired,
    }).isRequired,
  }).isRequired,
};

export default ThemePropTypes;
